import React from 'react';
import { useT } from '../salesI18n';

export const STATUS_STYLES = {
  new: { badge: 'bg-blue-50 text-blue-700 border-blue-200', bar: 'bg-blue-500', soft: 'bg-blue-50 text-blue-700', dot: 'bg-blue-500' },
  visit_scheduled: { badge: 'bg-green-50 text-green-700 border-green-200', bar: 'bg-green-500', soft: 'bg-green-50 text-green-700', dot: 'bg-green-500' },
  measured: { badge: 'bg-violet-50 text-violet-700 border-violet-200', bar: 'bg-violet-500', soft: 'bg-violet-50 text-violet-700', dot: 'bg-violet-500' },
  proposal_sent: { badge: 'bg-amber-50 text-amber-700 border-amber-200', bar: 'bg-amber-400', soft: 'bg-amber-50 text-amber-700', dot: 'bg-amber-400' },
  won: { badge: 'bg-teal-50 text-teal-800 border-teal-200', bar: 'bg-teal-600', soft: 'bg-teal-50 text-teal-700', dot: 'bg-teal-600' },
  lost: { badge: 'bg-red-50 text-red-700 border-red-200', bar: 'bg-red-500', soft: 'bg-red-50 text-red-700', dot: 'bg-red-500' },
};

export const STATUS_ORDER = ['new', 'visit_scheduled', 'measured', 'proposal_sent', 'won', 'lost'];

export const VISIT_TYPE_STYLES = { measurement: 'bg-violet-50 text-violet-700 border-violet-200', sales: 'bg-teal-50 text-teal-700 border-teal-200', follow_up: 'bg-amber-50 text-amber-700 border-amber-200' };

const base = 'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap';

export const StatusBadge = ({ status, className = '', testId }) => {
  const { t } = useT();
  const s = STATUS_STYLES[status] || STATUS_STYLES.new;
  return (
    <span data-testid={testId || `lead-status-badge-${status}`} className={`${base} ${s.badge} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {t.status[status] || status}
    </span>
  );
};

export const VisitTypeBadge = ({ type, className = '' }) => {
  const { t } = useT();
  return <span className={`${base} ${VISIT_TYPE_STYLES[type] || VISIT_TYPE_STYLES.sales} ${className}`}>{t.visitType[type] || type}</span>;
};

export const Chip = ({ children, tone = 'bg-white/80 text-slate-700 border-slate-200', className = '', ...props }) => (
  <span className={`${base} ${tone} ${className}`} {...props}>{children}</span>
);
